import { Button, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setApiUrlInStorage } from "../helpers/helpers";


const ApiUrl = () => {

  const [error, setError] = useState(false);
  const [apiUrlStr, setApiUrlStr] = useState("");

  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    setError(false);
    if (apiUrlStr.length === 0) {
      setError(true);
      return;
    }

    setApiUrlInStorage(apiUrlStr);
    navigate('/');
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}
    >
      <Grid item xs={12}>
        <div>
          <TextField
            onChange={(e) => setApiUrlStr(e.target.value)}
            sx={{ pb: 2 }}
            error={error}
            id="standard-error-helper-text"
            label="Please enter an API URL"
            helperText={error ? 'Missing URL' : ''}
            variant="standard"
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" onClick={(e) => handleClick(e)}>Submit</Button>
      </Grid>
    </Grid>
  );
}

export default ApiUrl;